import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { Box } from "@mui/material";
import ProgressCom from "../../components/ProgressCom";
import CustomPagination from "../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import { UseProductCluster } from "./UseProductCluster";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import BrandSearchCom from "../../basic-information/brand/BrandSearchCom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useLocation } from "react-router-dom";

export default function ClusterBrand(props) {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { addclusterBrand } = UseProductCluster();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [name, setName] = useState("");
  const [addBrand, setAddBrand] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    id: props.ClusterID,
    brandID: "",
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "rowIndex",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "brandID",
      width: 90,
      align: "center",
      headerName: "کد برند",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "title",
      width: 180,
      align: "center",
      headerName: "نام برند",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 80,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.title,
                id: cellValues.row.id,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addBrand",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              // setScrollTo(undefined);
              location.state = null;
              setAddBrand(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Dialog
      PaperProps={
        {
          // elevation: 1,
        }
      }
      sx={{ zIndex: 200 }}
      fullWidth
      open={props.showBrands}
      onClose={() => props.setShowBrands(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ p: 1, px: 2 }}
        color="secondary"
        id="alert-dialog-title"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!addBrand ? (
            <Typography color="secondary" variant="subtitle2">
              لیست برندها
            </Typography>
          ) : (
            <Typography variant="subtitle2">برند را انتخاب کنید</Typography>
          )}
          {!addBrand ? (
            <IconButton
              onClick={() => {
                props.setShowBrands(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => {
                setAddBrand(false);
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {!addBrand ? (
          <Box sx={{ height: "18rem" }}>
            {props.rows ? (
              <DataGrid
                className="ltr-grid"
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                rows={props.rows ? props.rows : []}
                page={pageState.page - 1}
                pageSize={20}
                Pagination
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...pageState, page: newPage + 1 }));
                }}
                rowCount={
                  props.rows && props.rows.length ? props.rows.length : 1
                }
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    nofab: true,
                    noPageCount: true,
                    rowCount:
                      props.rows && props.rows.length ? props.rows.length : "",
                    isLtr: true,
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: "id",
                        sort: "asc",
                      },
                    ],
                  },
                }}
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              mt: 1,
            }}
          >
            <BrandSearchCom
              setName={setName}
              selectedBrandID={stateAdd.brandID}
              setter={setStateAdd}
              lvl1State={stateAdd}
            ></BrandSearchCom>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateAdd.brandID) {
                    enqueueSnackbar("برند را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  setProgress(true);
                  addclusterBrand(stateAdd, () => {
                    props.callback(props.ClusterID);
                    setAddBrand(false);
                    setStateAdd({ ...stateAdd, brandID: "" });
                  });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    if (!stateAdd.brandID) {
                      enqueueSnackbar("برند را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    setProgress(true);
                    addclusterBrand(stateAdd, () => {
                      props.callback(props.ClusterID);
                      setAddBrand(false);
                      setStateAdd({ ...stateAdd, brandID: "" });
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => props.setShowBrands(false)}
                color="secondary"
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"برند"}
          callback={() => {
            props.deleteCallback(deleteState.id);
          }}
        ></DeleteRow>
      </DialogContent>
    </Dialog>
  );
}
